export default (state, postArr) => {
    state.latestPosts = postArr
}
